import React, { useCallback } from "react";
import { useTranslation } from "react-i18next";
import {
  DuplicateIcon,
  EditIcon,
  IconButton,
  RecurringCheckmarkIcon,
  Tooltip,
  TrashIcon,
} from "@activecollab/components";
import PropTypes from "prop-types";
import { DuplicateAction } from "~/components/ActionElements/index.jsx";
import { useRecurringTaskContext } from "~/components/Providers/RecurringTask/context";
import TrashTaskContainer from "../../TrashTaskContainer";

export const StartMenuBottomOptions = ({
  taskName,
  taskId,
  onEditButtonClick,
  onMoveToTrash,
  onDuplicate,
  recurringTasksEnabled,
  projectId,
}) => {
  const { t } = useTranslation();
  const { setParams } = useRecurringTaskContext();

  const createRecurringTask = useCallback(() => {
    setParams({ open: true, taskId, projectId });
  }, [projectId, setParams, taskId]);

  return (
    <div className="tw-flex tw-justify-between tw-mx-6 tw-mt-4 tw-mb-3">
      <Tooltip title={t("Edit")}>
        <IconButton
          type="button"
          variant="text gray"
          onClick={onEditButtonClick}
        >
          <EditIcon />
        </IconButton>
      </Tooltip>
      <Tooltip title={t("Duplicate")}>
        <DuplicateAction
          value={taskName}
          title={t("Duplicate Task")}
          labelText={t("Task name")}
          explainerText={t("All task properties, including subtasks will be copied to the new task.")}
        >
          <IconButton
            type="button"
            variant="text gray"
            onClick={onDuplicate}
          >
            <DuplicateIcon />
          </IconButton>
        </DuplicateAction>
      </Tooltip>
      {recurringTasksEnabled ? (
        <Tooltip title={t("Create Recurring Task")}>
          <IconButton
            type="button"
            variant="text gray"
            onClick={createRecurringTask}
          >
            <RecurringCheckmarkIcon />
          </IconButton>
        </Tooltip>
      ) : null}

      <TrashTaskContainer
        taskId={taskId}
        onClick={onMoveToTrash}
      >
        <div>
          <Tooltip title={t("Delete")}>
            <IconButton
              type="button"
              variant="text gray"
            >
              <TrashIcon />
            </IconButton>
          </Tooltip>
        </div>
      </TrashTaskContainer>
    </div>
  );
};

StartMenuBottomOptions.propTypes = {
  taskName: PropTypes.string,
  taskId: PropTypes.number,
  onEditButtonClick: PropTypes.func,
  onMoveToTrash: PropTypes.func,
  onDuplicate: PropTypes.func,
  recurringTasksEnabled: PropTypes.bool,
  projectId: PropTypes.number,
};

StartMenuBottomOptions.defaultProps = {
  taskName: "",
  onEditButtonClick: () => {},
  onMoveToTrash: () => {},
  onDuplicate: () => {},
  onMakeRecurring: () => {},
};
